import { format, isValid } from 'date-fns';

/** ISO date-time -> "MMM d, yyyy HH:mm" (falls back to the raw string, then em dash). */
export function formatModifiedAt(iso?: string | null): string {
  if (!iso) return '—';
  const d = new Date(iso);
  return isValid(d) ? format(d, 'MMM d, yyyy HH:mm') : iso;
}

/** Byte count -> human string (e.g. "1.2 MB"); em dash when absent. */
export function formatBytes(bytes?: number | null): string {
  if (bytes == null) return '—';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

/** "packageId@version" display label with safe fallbacks. */
export function packageLabel(packageId?: string | null, version?: string | null): string {
  const id = packageId?.trim() || 'unknown-package';
  const v = version?.trim();
  return v ? `${id}@${v}` : id;
}
